<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>文章</el-breadcrumb-item>
        <el-breadcrumb-item>文章管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col class="'toolbar" style="text-align: right;">
      <el-form :inline="true" size="small" :model="sData" ref="ruleForm"  class="form-inline">
        <el-form-item label="分类名称">
          <el-input v-model="sData.title_icontains" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="loadArticlePage(1)"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>文章搜索</el-button>
            <el-button type="primary" @click="addArticleShow = true"><i class="el-icon-plus" style="font-weight: bolder; margin-right: 6px;"></i>新增文章</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
      <el-dialog :visible.sync="addArticleShow" :before-close="handleClose" width="50%">
        <span>
            <el-form :model = "newArticle" ref= "newarticle" label-width="110px">
              <el-form-item label="文章标题" prop="title" :rules="{required: true, message: '文章标题不能为空', trigger: 'blur'}">
                <el-input v-model="newArticle.title" placeholder="请输入文章标题" :rules="{required: true, message: '文章标题不能为空', trigger: 'blur'}"></el-input>
              </el-form-item>
              <el-form-item label="文章分类" :rules="{required: true, message: '文章分类不能为空', trigger: 'blur'}">
                <el-select v-model="newArticle.classify_id" placeholder="请选择文章分类">
                  <el-option v-for="item in currPg" :key="item.ID" :label="item.title" :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单页主题" prop="subject">
                <el-input v-model="newArticle.subject" placeholder="请输入单页主题(显示标题与SEO标题不同)" required></el-input>
              </el-form-item>
               <el-form-item label="文章标签" prop="keywords" :rules="{required: true, message: '文章标签不能为空', trigger: 'blur'}">
                <el-input v-model="newArticle.keywords" placeholder="请输入分类关键词" required></el-input>
              </el-form-item>
               <el-form-item label="文章简介" prop="synopsis" :rules="{required: true, message: '文章简介不能为空', trigger: 'blur'}">
                <el-input type="textarea" :rows="7" v-model="newArticle.synopsis" placeholder="请用250内个字符介绍您的分类" required></el-input>
              </el-form-item>
              <el-form-item label="文章内容" prop="description" :rules="{required: true, message: '文章内容不能为空', trigger: 'blur'}">
                <vue-editor v-model="newArticle.description" style="height: 400px; overflow-y: auto;" @imageAdded="imgLoad" useCustomImageHandler></vue-editor>
              </el-form-item>
              <el-form-item>
                <el-button @click="addArticleShow = false">取 消</el-button>
                <el-button type="primary" @click="addArticle('newarticle')">确 定</el-button>
              </el-form-item>
            </el-form>
          </span>
      </el-dialog>
    </el-col>
    <el-col>
      <el-table :data="articleList" stripe style="width: 100%">
        <el-table-column prop="ID" label="文章ID" width="100"></el-table-column>
        <el-table-column prop="title" label="文章标题" width="300"></el-table-column>
        <el-table-column prop="subject" label="文章主题" width="300"></el-table-column>
        <el-table-column prop="keywords" label="关键词" width="300"></el-table-column>
        <el-table-column prop="creatTime" label="创建时间" :formatter="creatTimeShow" width="300"></el-table-column>
        <el-table-column prop="viewCount" label="访问统计" width="300"></el-table-column>
        <el-table-column prop="status" :formatter="articleStatus" label="状态" width="100"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
           <el-button-group>
             <el-button @click="articleRemove(scope.row)" type="text" size="small">删除</el-button>
             <el-button @click="articleExStatus(scope.row)" type="text" size="small">状态</el-button>
             <el-button type="text" size="small" @click="articleEdit(scope.row)">编辑</el-button>
           </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :visible.sync="editArticleShow" :before-close="handleClose" width="50%">
        <span>
            <el-form :model = "currEdit" ref= "editarticle" label-width="110px">
              <el-form-item label="文章标题" prop="title" :rules="{required: true, message: '文章标题不能为空', trigger: 'blur'}">
                <el-input v-model="currEdit.title" placeholder="请输入文章标题" :rules="{required: true, message: '文章标题不能为空', trigger: 'blur'}"></el-input>
              </el-form-item>
              <el-form-item label="文章分类" :rules="{required: true, message: '文章分类不能为空', trigger: 'blur'}">
                <el-select v-model="currEdit.classify_id" placeholder="请选择文章分类">
                  <el-option v-for="item in currPg" :key="item.ID" :label="item.title" :value="item.ID"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单页主题" prop="subject">
                <el-input v-model="currEdit.subject" placeholder="请输入单页主题(显示标题与SEO标题不同)" required></el-input>
              </el-form-item>
               <el-form-item label="文章标签" prop="keywords" :rules="{required: true, message: '文章标签不能为空', trigger: 'blur'}">
                <el-input v-model="currEdit.keywords" placeholder="请输入分类关键词" required></el-input>
              </el-form-item>
               <el-form-item label="文章简介" prop="synopsis" :rules="{required: true, message: '文章简介不能为空', trigger: 'blur'}">
                <el-input type="textarea" :rows="7" v-model="currEdit.synopsis" placeholder="请用250内个字符介绍您的分类" required></el-input>
              </el-form-item>
              <el-form-item label="文章内容" prop="description" :rules="{required: true, message: '文章内容不能为空', trigger: 'blur'}">
                <vue-editor v-model="currEdit.description" style="height: 400px; overflow-y: auto;" @imageAdded="imgLoad" useCustomImageHandler></vue-editor>
              </el-form-item>
              <el-form-item>
                <el-button @click="editArticleShow = false">取 消</el-button>
                <el-button type="primary" @click="editArticle('editarticle')">确 定</el-button>
              </el-form-item>
            </el-form>
          </span>
      </el-dialog>
    </el-col>
    <el-col :span="24" class="pagenav" style="margin-top: 42px;">
        <el-pagination
        @current-change="loadArticlePage"
        :current-page="currPage.page"
        :page-sizes="[12]"
        :page-size="12"
        layout="total, sizes, prev, pager, next, jumper"
        :total="currPage.total">
      </el-pagination>
    </el-col>
  </el-row>
</template>
<script>
import ElCol from 'element-ui/packages/col/src/col'
export default {
  components: {ElCol},
  name: 'Article',
  data () {
    return {
      sData: {},
      addArticleShow: false,
      newArticle: {},
      editorOption: {},
      currPg: [],
      currPage: {page: 1, total: 0},
      articleList: [],
      currEdit: {},
      editArticleShow: false
    }
  },
  mounted: function () {
    this.loadclassify()
    this.loadArticlePage(1)
  },
  methods: {
    imgLoad: function (file, Editor, cursorLocation, resetUploader) {
      var foemData = new FormData()
      foemData.append('upload', file)
      var api = this.upurl
      var that = this
      that.$http.post(api, foemData).then(function (ret) {
        var imgurl = 'https:' + ret.data.data.url
        Editor.insertEmbed(cursorLocation, 'image', imgurl)
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    loadclassify: function () {
      var data = this.sData
      data.page = 1
      data.num = 99999999
      data.method = 'article.clpage'
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.currPg = ret.body.data.data
      })
    },
    chkpage: function (value) {
      alert(value)
    },
    addArticle: function (fn) {
      var that = this
      var currp = that.currPage.page
      that.$refs[fn].validate(function (valid) {
        if (valid) {
          var data = that.newArticle
          data.method = 'article.addarticle'
          that.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('新文章成功提交')
              that.loadArticlePage(currp)
              that.addArticleShow = false
            } else {
              that.$alert('新文章提交失败，请稍后重试!')
            }
          })
        } else {
          that.$alert('请检查文章内容是否正常填写!')
        }
      })
    },
    loadArticlePage: function (page) {
      var data = this.sData
      data.page = page
      data.num = 12
      data.method = 'article.articlepage'
      Object.assign(data, this.sData)
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.currPage.page = ret.body.data.page
        that.currPage.total = ret.body.data.total
        that.articleList = ret.body.data.data
      })
    },
    creatTimeShow: function (data) {
      var d = new Date(data.creatTime)
      return (d.toLocaleString())
    },
    articleStatus: function (data) {
      if (data.status) {
        return ('启用')
      } else {
        return ('禁用')
      }
    },
    articleExStatus: function (row) {
      var data = {AID: row.ID, method: 'article.articlestate'}
      var that = this
      var curr = that.currPage.page
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.code === 200) {
          that.$message.success('分类状态修改成功')
          that.loadArticlePage(curr)
        } else {
          that.$alert('分类状态修改失败，请稍后重试!')
        }
      })
    },
    articleEdit: function (row) {
      this.currEdit = row
      this.editArticleShow = true
    },
    editArticle: function (fn) {
      var that = this
      var curr = that.currPage.page
      this.$refs[fn].validate(valid => {
        if (valid) {
          var data = that.currEdit
          delete data.category
          data.method = 'article.articleupdate'
          this.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.code === 200) {
              that.$message.success('文章修改成功')
              that.loadArticlePage(curr)
              that.editArticleShow = false
            } else {
              that.$alert('文章修改失败，请稍后重试!')
            }
          })
        }
      })
    },
    articleRemove: function (row) {
      var para = {}
      para.method = 'article.removearticle'
      para.AID = row.ID
      var that = this
      this.$http.post(that.$apiurl, para).then(function (ret) {
        if (ret.body.code === 200) {
          that.$message.success('文章删除成功')
          that.loadArticlePage(that.currPage.page)
        } else {
          that.$alert('文章删除失败，请稍后重试!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shop/Article.vue